import { localized, type DuoVideoTool } from '@/config/ai-tools';
import { m } from '@/paraglide/messages.js';

/**
 * Studio and page wording for a tool: its own `copy` override when it has
 * one, otherwise the rap-duo default from the message files.
 */
export function resolveToolCopy(tool: DuoVideoTool, locale: string) {
  const copy = tool.copy ?? {};
  const pick = (override: Parameters<typeof localized>[0] | undefined, fallback: () => string) =>
    override ? localized(override, locale) : fallback();

  return {
    photoFirst: pick(copy.photoFirst, () => m['directory.ai_tools.studio.photo_you']()),
    photoSecond: pick(copy.photoSecond, () => m['directory.ai_tools.studio.photo_duo']()),
    stepStage: pick(copy.stepStage, () => m['directory.ai_tools.studio.step_stage']()),
    stepTopic: pick(copy.stepTopic, () => m['directory.ai_tools.studio.step_topic']()),
    topicPlaceholder: pick(copy.topicPlaceholder, () => m['directory.ai_tools.studio.topic_placeholder']()),
    topicHint: pick(copy.topicHint, () => m['directory.ai_tools.studio.topic_hint']()),
    /** Button label for a quality tier costing `credits`. */
    generate: (credits: number) =>
      copy.generate
        ? `${localized(copy.generate, locale)} · ${m['directory.ai_tools.studio.credits']({ credits })}`
        : m['directory.ai_tools.studio.generate']({ credits }),
    starting: pick(copy.starting, () => m['directory.ai_tools.studio.starting']()),
    trustTitle: pick(copy.trustTitle, () => m['directory.ai_tools.trust.song_title']()),
    trustBody: pick(copy.trustBody, () => m['directory.ai_tools.trust.song_body']()),
    galleryTitle: pick(copy.galleryTitle, () => m['directory.ai_tools.gallery_title']()),
    galleryDescription: pick(copy.galleryDescription, () => m['directory.ai_tools.gallery_description']()),
    stagesTitle: pick(copy.stagesTitle, () => m['directory.ai_tools.stages_title']()),
    ideasTitle: pick(copy.ideasTitle, () => m['directory.ai_tools.ideas_title']()),
    relatedTitle: pick(copy.relatedTitle, () => m['directory.ai_tools.related_title']()),
    ctaDescription: pick(copy.ctaDescription, () => m['directory.ai_tools.cta_description']()),
    ctaButton: pick(copy.ctaButton, () => m['directory.ai_tools.cta_button']()),
  };
}
